import {useMediaQuery} from "react-responsive";


export const useLargeScreen = () => {
  return useMediaQuery({
    query: '(min-width: 600px)'
  })
}
